<template>
  <q-form class="q-pa-xs" @submit.stop="search">
    <div class="row items-center">
      <q-input
          dense
          label="Número IAC"
          outlined
          v-model="numeroUnicoTema"
          class="q-ma-xs"
          @input="handleInput"
          @blur="onBlur"
          maxlength="32"
          mask="############"
          style="width: 15%;"
      />
      <q-input
          dense
          label="Questão submetida a julgamento"
          outlined
          autogrow
          v-model="questao"
          class="q-ma-xs"
          @input="handleInput"
          style="width: 50%;"
      />
      <q-btn type="submit" color="primary" icon="search" class="q-ma-xs">
        <q-tooltip class="bg-indigo" anchor="top middle" self="bottom middle" :offset="[10, 10]"
                   transition-show="rotate"
                   transition-hide="rotate"
        >Pesquisar
        </q-tooltip>
      </q-btn>
      <q-btn
          @click="limpar"
          icon="cleaning_services"
          type="reset"
          color="primary"
          class="q-ma-xs">
        <q-tooltip class="bg-red" anchor="top middle" self="bottom middle" :offset="[10, 10]"
                   transition-show="rotate"
                   transition-hide="rotate"
        >
          Limpar
        </q-tooltip>
      </q-btn>
      <q-btn
          v-if="admin"
          icon="post_add"
          color="primary"
          :elevation="false"
          @click="$router.push('/iac')">
        <q-tooltip class="bg-indigo" anchor="top middle" self="bottom middle" :offset="[10, 10]"
                   transition-show="rotate"
                   transition-hide="rotate"
        >Novo
        </q-tooltip>
      </q-btn>
      <q-toggle
          @click="pesquisaAvancada"
          v-model="mod"
          color="primary"
          icon="search"
          label="Pesquisa Avançada"
      />
      <q-input
          v-if="modAvancada"
          dense
          label="Tese jurídica fixada"
          outlined
          autogrow
          v-model="tese"
          class="q-ma-xs"
          @input="handleInput"
          style="width: 48%;"
      />
      <q-input
          v-if="modAvancada"
          dense
          label="Processo PJE"
          outlined
          v-model="numProcessoPJe"
          class="q-ma-xs"
          mask="#######-##.####.#.##.####"
          style="width: 20%;"
      />
      <q-select
          v-if="modAvancada"
          dense
          class="q-ma-xs"
          label="Situação"
          :placeholder="situacao ? 'Selecionar' : ''"
          :use-input="!situacao"
          @filter="situacoesFilter"
          outlined
          v-model="situacao"
          option-value="id"
          option-label="descricao"
          :options="filteredSituacoes"
          menuAnchor="bottom left"
          menuSelf="top left"
          :use-chips="!!situacao"
          popup-content-class="tjpa-select-input"
          style="width: 20%;"
      />
    </div>
  </q-form>
</template>

<script setup>
import { useIacSituacaoStore } from "@/store/iac-situacao-store";
import { useIacStore } from "@/store/iac-store";
import { computed, ref, watch } from "vue";
import { filterFunction } from "../DemandasRepetitivas";
import {useUserStore} from "@/store/user-store";
const userStore = useUserStore();

const situacaoStore = useIacSituacaoStore();
situacaoStore.fetch();

const iacStore = useIacStore();

const admin = computed(() => userStore.admin);

const situacoes = computed(() => situacaoStore.all);
const filteredSituacoes = ref([]);

const numeroUnicoTema = ref(iacStore.numeroUnicoTema);
const numProcessoPJe = ref(iacStore.numProcessoPJe);
const questao = ref(iacStore.questao);
const tese = ref(iacStore.tese);
const situacao = ref(situacoes.value.find(s => s.id == iacStore.situacao));

const _modAvancada = ref(false);

const modAvancada = computed({get:() => (_modAvancada.value),set:v=>(_modAvancada.value = v)});

const mod = ref(false);

watch(situacao, () => (iacStore.situacao = situacao.value?.id || 0));
watch(numProcessoPJe, () => (iacStore.numProcessoPJe = numProcessoPJe.value));
watch(
  numeroUnicoTema,
  () => (iacStore.numeroUnicoTema = numeroUnicoTema.value)
);
watch(questao, () => (iacStore.questao = questao.value));
watch(tese, () => (iacStore.tese = tese.value));

const situacoesFilter = (v, up) =>
  filterFunction(...[filteredSituacoes.value, situacoes.value, v, up]);

const search = () => iacStore.fetchPage();
const limpar = () => {
  numeroUnicoTema.value = "";
  numProcessoPJe.value = "";
  questao.value = "";
  tese.value = "";
  situacao.value = null;
  iacStore.resetPagination();
  search()
};

const pesquisaAvancada = () => {
  numProcessoPJe.value = "";
  tese.value = "";
  situacao.value = null;
  modAvancada.value = modAvancada.value ? false : true;
}

const handleInput = (event) => {
  const value = event.target.value;
  if (value < 0) {
    event.target.value = 0;
  }
};

const onBlur = () => {
  if (numeroUnicoTema.value < 0) {
    numeroUnicoTema.value = null;
  }
};

</script>

<style lang="scss">
.tjpa-select-input {
  max-height: 30vh;
}
</style>
